<template>
    <collapsible-content-section
        class="collapsible-content-section-module"
        :title="attributes.collapsibleContent_title"
        :intro="attributes.intro"
        :collapse-title="attributes.collapse_title"
        :collapse-content="attributes.collapse_content"
        :centered="attributes.centered"
    />
</template>

<script>
    import CollapsibleContentSection from '../../../organisms/CollapsibleContentSection/CollapsibleContentSection';

    export default {
        name: 'collapsible-content-section-module',

        components: { CollapsibleContentSection },

        props: {
            attributes: {
                type: Object,
                default: () => ({}),
            },
        },
    };
</script>
